import { openBlock as e, createElementBlock as l, createElementVNode as c } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, o = /* @__PURE__ */ c("path", {
  "fill-rule": "evenodd",
  d: "M3 21.703c.885 0 1.594-.41 2.139-1.026.527-.596.922-1.401 1.24-2.282.159-.439.303-.913.438-1.413l8.404-8.404c.31 1.056.588 2.207.858 3.386l-8.98 8.98a.5.5 0 0 0 .708.706l8.534-8.534c.265 1.17.533 2.34.829 3.414l-4.39 4.389a.5.5 0 1 0 .707.707l4.006-4.005c.087.27.176.532.27.781.297.8.648 1.535 1.085 2.105l-.387.387a.5.5 0 1 0 .707.708l.387-.387c.407.3.887.488 1.445.488a.75.75 0 0 0 0-1.5c-.275 0-.559-.125-.88-.506-.333-.396-.65-1.005-.952-1.818-.534-1.433-.956-3.296-1.405-5.277l-.186-.816c-.511-2.237-1.08-4.565-1.9-6.336-.803-1.732-2-3.247-3.908-3.247-1.925 0-3.057 1.54-3.777 3.275-.736 1.773-1.196 4.104-1.618 6.336l-.083.438c-.4 2.118-.777 4.121-1.323 5.634-.29.807-.608 1.408-.952 1.796-.327.37-.651.521-1.016.521a.75.75 0 0 0 0 1.5ZM14.88 7.505l-7.624 7.624c.177-.835.34-1.7.501-2.558l.09-.479c.145-.764.29-1.517.445-2.24l5.185-5.186c.29.363.568.832.839 1.415.202.436.389.914.564 1.424Zm-2.139-3.517a1.808 1.808 0 0 0-.972-.285c-.94 0-1.712.711-2.392 2.35-.24.58-.451 1.235-.642 1.942l4.006-4.007Z",
  "clip-rule": "evenodd"
}, null, -1), n = [
  o
];
function r(a, d) {
  return e(), l("svg", t, [...n]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
